import React from "react";
import { StornoDialog } from "../components/StornoDialog/StornoDialog";
import { useStornoDialog } from "../hooks/useStornoDialog";

export const StornoDialogContainer: React.FC = () => {
  const { stornoDialog, closeStornoDialog, handleStornoOffer } =
    useStornoDialog();

  if (!stornoDialog.isOpen || !stornoDialog.offerId) {
    return null;
  }

  return (
    <StornoDialog
      isOpen={stornoDialog.isOpen}
      offerId={stornoDialog.offerId}
      onClose={closeStornoDialog}
      onConfirm={async ({ offerId, stornoType }) => {
        await handleStornoOffer({ offerId, stornoType });
      }}
    />
  );
};
